import React from 'react'
import { map, isEmpty } from 'lodash/fp'
import { Link as GatsbyLink, useStaticQuery, graphql } from 'gatsby'

// Components

// Styling
import './footer.scss'

// Types
import NomAgencyYearBadge from 'components/NomAgencyYearBadge'
import { Logotype } from 'components/Header/Logotype'

interface Props {
  title: string
  children: React.ReactChild
}

interface Link {
  id: string
  title: string
  page: {
    slug: string
    title: string
  }
}

interface QueryResponse {
  contentfulMenu: {
    id: string
    links: Link[]
  }
}

const Footer: React.FC<Props> = ({ title, children }) => {
  const { contentfulMenu } = useStaticQuery<QueryResponse>(graphql`
    query FooterNavigationQuery {
      contentfulMenu(location: { eq: "Footer Navigation" }) {
        id
        links {
          id
          title
          page {
            slug
            title
          }
        }
      }
    }
  `)

  return (
    <footer className="site-footer">
      <a href="https://camelonta.se/" className="site-footer__logo">
        <Logotype theme="Light" scrollClass="top" />
      </a>
      <div className="site-footer__contact">
        <div className="site-footer__contact-row">
          <div className="site-footer__contact-col">
            <p>Säg hej!</p>
            <p>
              <a href="tel:086188550">+46 8 618 85 50</a>
            </p>
            <p>
              <a href="mailto:kontakt@camelonta.se">kontakt@camelonta.se</a>
            </p>
            <br />
            <p>Jobb eller LIA?</p>
            <p>
              <a href="mailto:career@camelonta.se">career@camelonta.se</a>
            </p>
          </div>
          <div className="site-footer__contact-col">
            <p>Hammarby Kajgatan 12</p>
            <p>120 30 Stockholm</p>
          </div>
          <div className="site-footer__contact-col">
            <p>
              <a href="https://www.instagram.com/camelonta/">Instagram</a>
            </p>
            <p>
              <a href="https://www.linkedin.com/company/camelonta/">LinkedIn</a>
            </p>
          </div>
          <div className="site-footer__contact-col site-footer__contact-title">
            <h4 className="site-footer__title">{title}</h4>
          </div>
        </div>
      </div>
      <div className="site-footer__content">
        <div className="site-footer__inner-content">
          <div className="site-footer__text">{children}</div>
        </div>

        <div className="site-footer__badges">
          <NomAgencyYearBadge />
        </div>
      </div>

      <hr className="site-footer__divider" />
      <div className="site-footer__copyright-row">
        <div className="site-footer__copyright">
          Copyright © 2025 Camelonta AB
        </div>
        {contentfulMenu && (
          <div className="site-footer__navigation">
            <ul className={'site-footer__nav-list'}>
              {!isEmpty(contentfulMenu.links) &&
                map(
                  (link) => (
                    <li key={link.id}>
                      <GatsbyLink to={`/${link.page.slug}`}>
                        {link.title}
                      </GatsbyLink>
                    </li>
                  ),
                  contentfulMenu.links
                )}
            </ul>
          </div>
        )}
      </div>
    </footer>
  )
}

export default Footer
